const rss = {
  title: "RSS-ленты",
  description: "Новости строительства и недвижимости Израиля",
  feeds: "Ленты",
  articles: "Статьи",
  unread: "Непрочитанные",
  starred: "Избранные",
  allArticles: "Все статьи",
  addFeed: "Добавить ленту",
  feedUrl: "URL RSS",
  feedTitle: "Название ленты",
  keywords: "Ключевые слова",
  keywordsPlaceholder: "недвижимость, строительство, подрядчик...",
  syncNow: "Синхронизировать",
  syncing: "Синхронизация...",
  lastSynced: "Последняя синхронизация",
  never: "Не синхронизировано",
  activeFeeds: "Активные ленты",
  totalArticles: "Всего статей",
  unreadCount: "Непрочитанные",
  markRead: "Отметить прочитанным",
  markAllRead: "Отметить все прочитанными",
  viewAll: "Показать все",
  openArticle: "Открыть статью",
  noArticles: "Статей пока нет — запустите синхронизацию",
  noFeeds: "Нет активных лент",
  removeFeed: "Удалить ленту",
  defaultFeed: "Стандартная лента",
  customFeed: "Пользовательская лента",
  error: "Ошибка",
  synced: "Синхронизировано",
  stale: "Устарело",
  matchedKeywords: "Совпавшие ключевые слова",
  filterByFeed: "Фильтр по ленте",
  filterAll: "Все",
  ago: "назад",
  minutes: "минут",
  hours: "часов",
  days: "дней",
  today: "Сегодня",
  yesterday: "Вчера",
} as const;
export default rss;
